<script setup lang="ts">
defineOptions({ inheritAttrs: false })
</script>

<template>
  <transition
    enter-active-class="transition-all ease-out duration-150"
    enter-from-class="opacity-0 -translate-y-2"
    enter-to-class="opacity-100 translate-y-0"
    leave-active-class="transition-all ease-in duration-150"
    leave-from-class="opacity-100 translate-y-0"
    leave-to-class="opacity-0 -translate-y-2"
    v-bind="$attrs"
  >
    <slot></slot>
  </transition>
</template>
